'use client';

import dynamic from 'next/dynamic';

import { TopNavigationUIPropTypes } from './TopNavigation.types';

// `next/dynamic` with `ssr: false` is only allowed inside Client Components in
// Next.js 15+/16, so the dynamic import lives in this thin client wrapper.
const TopNavigationUI = dynamic(() => import('./TopNavigationUI'), { ssr: false });

export default function TopNavigationClient(props: TopNavigationUIPropTypes) {
  return <TopNavigationUI {...props} />;
}
